export default __webpack_public_path__ + "static/media/avgPowerFactorIcon.0ac7e112.svg";